import React, { useState } from "react";
import { Button, message, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { buildCSVResult } from "../csvUtils";
import ImportPreviewModal from "./PreviewModal";

function CSVImportButton({
  onConfirm,
  buttonLabel = "Importer un CSV",
  disabled = false,
}) {
  const [loading, setLoading] = useState(false);
  const [pendingResult, setPendingResult] = useState(null);

  const handleFile = (file) => {
    setLoading(true);

    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const result = buildCSVResult(event.target.result, file.name);

        if (!result) {
          message.warning("CSV vide");
          return;
        }

        setPendingResult(result);
      } catch (error) {
        message.error(`Erreur de parsing : ${error.message}`);
      } finally {
        setLoading(false);
      }
    };

    reader.onerror = () => {
      setLoading(false);
      message.error("Erreur de lecture du fichier");
    };

    reader.readAsText(file, "UTF-8");

    return false;
  };

  const confirmImport = () => {
    if (!pendingResult) {
      return;
    }

    onConfirm(pendingResult);

    if (pendingResult.duplicates.length > 0) {
      message.warning(
        `Colonnes en double renommées automatiquement : ${pendingResult.duplicates.join(", ")}`
      );
    }

    setPendingResult(null);
  };

  const cancelImport = () => {
    setPendingResult(null);
    message.info("Import annulé");
  };

  return (
    <>
      <Upload
        accept=".csv,text/csv"
        beforeUpload={handleFile}
        showUploadList={false}
        maxCount={1}
        disabled={disabled}
      >
        <Button icon={<UploadOutlined />} loading={loading} disabled={disabled}>
          {buttonLabel}
        </Button>
      </Upload>

      <ImportPreviewModal
        open={pendingResult !== null}
        pendingResult={pendingResult}
        onConfirm={confirmImport}
        onCancel={cancelImport}
      />
    </>
  );
}

export default CSVImportButton;
